import { Fragment } from "react";
import clsx from "clsx";

const Hero = () => {
    return (
        <Fragment>
            <header className={clsx(
                "w-full bg-neutral-20"
            )}>
                <div className="max-w-[1440px] mx-auto tablet:py-[72px] py-20 phone:pt-10 phone:pb-14 px-6 tablet:px-8 desktop:px-[120px]">
                    <div className="w-full tablet:max-w-[610px] desktop:max-w-[610px] mx-auto">
                        <h1 className="text-heading-1 tablet:text-heading-2 text-center phone:text-heading-3 desktop:text-heading-1 font-semibold text-basier-circle-semibold text-neutral-100">Terms of Service</h1>
                        <p className="text-basier-circle-regular text-neutral-50 text-center font-normal tablet:text-md desktop:text-md text-md tracking-text leading-[27.2px] pt-4 md:text-center">
                            Effective date: September 21, 2022
                        </p>
                    </div>
                </div>
            </header>
        </Fragment>
    );
};

export default Hero;